// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment-old.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
/**
 * The environment variable to be shared accross the application
 */
export const environment = {
  //P&L Component
  PLComponentMenuFundosId:'HAbxA',
  plObject:'WXhQUHT',
  homePlObject:'YPDXWqP',
  //Accumulado Gestao Home
  HomeAccumuladoGestaoDates:'WtbpcQt',
  HomeAccumuladoGestaoConsolidated:'XBF',
  HomeAccumuladoGestaoTransfer:'GBHeEVQ',
  HomeAccumuladoGestaoRebate:'mwcHL',
  HomeAccumuladoGestaoIncome:'KbMsmXm',
  HomeAccumuladoGestaoSelectfund:'BKJRD',
  HomeAccumuladoGestaoTableDetail:'cPcgnWQ',
  //Accumulado Gestao Component
  AccumuladoGestaoSelectFund:'SF',
  AccumuladoGestaoConsolidated:'bHzmTJF',
  AccumuladoGestaoTransfer:'csUjgNU',
  AccumuladoGestaoRebate:'sNnKCH',
  AccumuladoGestaoIncome:'FwYwtYp',
  idObjRebates:'MwytDd',
  idObjDetails:'CrqJb',
  //Cotas component
  CotasObjectId:'JsPNaQe',
  //Fluxo Caixa component
  FluxoCaixaId:'DGpTj',
  FluxoCaixaDataliquidacao:'BwdPF',
  isQlikUat:false,

  // palmyra-needle-add-environment-var: Do not delete this line
  // basePath: '/ataouni-314028-app/services/rest',
  basePath: 'https://bff-backoffice.s3caceisinternal.com.br',

  basePathExternal: '/portal/services/rest',

  basePathExternalApi: '/portal/services/api',

  dhPath: '/portal/clearing',

  indexadorPah: '/portal/Indexador',

  fundoCotaPath: '/portal/fundocota',

  counterPartPath: '/portal/contraparte',

  lastrotPath: '/portal/lastro',

  msalUrl: 'https://www.s3caceis.com.br/portal/',

  soap_ticket: 'https://dlbticket.paas.santanderbr.corp/dlbticket/services/TicketEndpointService?wsdl',

  // B2C
  b2cPolicySignIn: 'B2C_1_Login',
  b2cAuthoritySignIn:
    'https://b2csantandercaceiscloud.b2clogin.com/b2csantandercaceiscloud.onmicrosoft.com/B2C_1_Login',

  b2cPolicyPasswordReset: 'B2C_1A_HISTORYResetPasswordDEMO',
  b2cAuthorityPasswordReset:
    'https://b2csantandercaceiscloud.b2clogin.com/b2csantandercaceiscloud.onmicrosoft.com/B2C_1A_HISTORYResetPasswordDEMO',

  b2cUserInfoScope:
    'https://b2csantandercaceiscloud.onmicrosoft.com/portal-bff-login/userinfo',
  b2cWebApiScope: 'https://www.s3caceis.com.br/',

  b2cChangePassword:
    'https://b2csantandercaceiscloud.b2clogin.com/b2csantandercaceiscloud.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_HISTORYResetPasswordDEMO&client_id=1c0bfe78-aa57-4f59-9ec2-09e6782609fd&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fb2c-layout.s3caceisinternal.com.br/prd/resetSuccess.html&scope=openid&response_type=code&prompt=login',

  b2cClientId: '940e3103-b492-418c-9008-0af563f4d5c7',
  b2cAuthorityDomain: 'https://b2csantandercaceiscloud.b2clogin.com',

  loginSSO : "https://www.santanderoper.com.br/",
  isUatOrProd :"PROD",

  //Qlik
  qlikUrl: 'qlik.s3caceis.com.br',
  qlikPort: 443,
  qlikPrefix: '/caceis/',
  qlikIsSecure: true,
  qlikAppIdPT: '9d2b00ef-a207-4f0c-8a9a-97c6a42ee96e',
  qlikAppIdEN: '9d2b00ef-a207-4f0c-8a9a-97c6a42ee96e',
  /* Do not write your custom code here, it will be replaced by the generated content */
  // end palmyra-needle-add-environment-var
  prefix: 's3brazilwebportalfe',
  production: false,
  mockService: [],
  showLogs: true,
  useEncrypt: false,
  appVersion: 1.0
}
